(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/lyckoplatsen/map-shared/map-create.js') >= 0) return;  svs.modules.push('/components/tur/lyckoplatsen/map-shared/map-create.js');

'use strict';

const {
  swe,
  sweInv,
  tileLayerUrl
} = svs.tur.lyckoplatsen.map;
const {
  isSelfService
} = svs.core.config.data.svsconfig;
const sweRectangleBounds = [[69.1, 10.4], [55.1, 24.3]];
const maxBounds = false;
const worldRectangleBounds = [[-90, -180], [90, 180]];

const expireTime = new Date(Date.now() + 59 * 60 * 1000);
const interval = setInterval(() => {
  const now = new Date();
  if (now >= expireTime) {
    clearInterval(interval);
    const startPageURL = "".concat(svs.core.urlMapping.get('lyckoplatsenHome'), "?sessionExpired");
    svs.utils.url.navigate(startPageURL);
  }
}, 5000);
const TILE_RESET_INTERVAL = 10000;
const ERROR_THRESHOLD = 0.7;
const THROTTLE_INTERVAL = 10000;
let tileLoadCount = 0;
let tileErrorCount = 0;
setInterval(() => {
  tileLoadCount = 0;
  tileErrorCount = 0;
}, TILE_RESET_INTERVAL);
const mapDefaults = {
  center: [62.935, 17.516],
  maxBounds,
  minZoom: 4,
  maxZoom: 15,
  zoom: 4,
  zoomSnap: 1,
  zoomControl: true,
  zoomAnimation: false,
  attributionControl: true,
  markerZoomAnimation: false,
  geoJson: false,
  geoJsonInv: true,
  geoJsonFill: false,
  dragging: true,
  scrollWheelZoom: true,
  type: 'singel',
  addGradients: false
};
function createMap(mapOptions) {
  const {
    nodeId,
    center,
    maxBounds,
    minZoom,
    maxZoom,
    zoom,
    zoomSnap,
    zoomControl,
    zoomAnimation,
    attributionControl,
    geoJson,
    geoJsonInv,
    geoJsonFill,
    dragging,
    scrollWheelZoom,
    type,
    keyboard,
    doubleClickZoom,
    boxZoom,
    touchZoom,
    tap,
    errorCallback,
    fadeAnimation,
    addGradients
  } = mapOptions;
  const mapRenderer = leaflet.svg({
    padding: 1
  });
  const map = leaflet.map(nodeId, {
    center,
    zoom,
    minZoom,
    maxZoom,
    maxBounds,
    zoomSnap,
    zoomControl: false,
    zoomAnimation,
    attributionControl,
    dragging,
    scrollWheelZoom,
    type,
    keyboard,
    doubleClickZoom,
    boxZoom,
    touchZoom,
    tap,
    fadeAnimation,
    addGradients
  });
  let paneName = '';
  if (type) {
    paneName = "type-".concat(type);
    map.createPane(paneName);
  }
  if (zoomControl) {
    leaflet.control.zoom({
      position: 'bottomleft'
    }).addTo(map);
  }
  const throttleErrorCallback = typeof errorCallback === 'function' ? _.throttle(errorCallback, THROTTLE_INTERVAL, {
    trailing: false
  }) : undefined;
  const checkForErrorThreshold = () => {
    const isErrorThresholdBreached = tileErrorCount / tileLoadCount > ERROR_THRESHOLD;
    if (isErrorThresholdBreached) {
      throttleErrorCallback === null || throttleErrorCallback === void 0 || throttleErrorCallback();
    }
  };
  if (attributionControl) {
    const tileLayer = leaflet.tileLayer(tileLayerUrl, {
      attribution: isSelfService ? "<div>&copy; OpenStreetMap</div>" : '<a href="https://www.openstreetmap.org/" target="_blank">&copy; OpenStreetMap</a>'
    });
    tileLayer.on('tileload', () => {
      tileLoadCount++;
    });
    tileLayer.on('tileerror', () => {
      tileErrorCount++;
      checkForErrorThreshold();
    });
    tileLayer.addTo(map);
  }
  if (geoJsonInv || addGradients) {
    map.on('layeradd', () => {
      const svg = map.getRenderer(map)._container;
      let defs = svg.querySelector('defs');
      if (!defs) {
        defs = document.createElementNS('http://www.w3.org/2000/svg', 'defs');
        svg.insertBefore(defs, svg.firstChild);
      }
      let gradientValues = 'cx="50%" cy="20%" r="50%"';
      if (type === 'play') {
        gradientValues = 'cx="50%" cy="30%" r="25%"';
      }
      const gradient = "\n        <radialGradient id=\"geojsonGradient\" ".concat(gradientValues, ">\n          <stop offset=\"0%\" stop-color=\"rgba(110, 186, 250, 1)\" />  \n          <stop offset=\"100%\" stop-color=\"rgba(32, 115, 229, 1)\" />\n        </radialGradient>\n      ");
      const outerGlowFilter = "\n        <filter id=\"outerGlow\" filterUnits=\"objectBoundingBox\" x=\"-50%\" y=\"-50%\" width=\"200%\" height=\"200%\">\n          <!-- 1) Get the shape's alpha -->\n          <feComposite in=\"SourceAlpha\" in2=\"SourceAlpha\" operator=\"over\" result=\"shape\"/>\n          \n          <!-- 2) Optionally grow it a bit so the blur starts just outside the edge -->\n          <feMorphology in=\"shape\" operator=\"dilate\" radius=\"2\" result=\"grown\"/>\n          \n          <!-- 3) Blur the grown outline -->\n          <feGaussianBlur in=\"grown\" stdDeviation=\"16\" result=\"blur\"/>\n          \n          <!-- 4) Color the blur -->\n          <feFlood flood-color=\"#001A3C\" flood-opacity=\"0.8\" result=\"color\"/>\n          <feComposite in=\"color\" in2=\"blur\" operator=\"in\" result=\"coloredBlur\"/>\n          \n          <!-- 5) Critically: remove the original shape area so glow is OUTSIDE only -->\n          <feComposite in=\"coloredBlur\" in2=\"shape\" operator=\"out\" result=\"outerOnly\"/>\n          \n          <!-- 6) Put original on top (so its edges stay crisp) -->\n          <feComposite in=\"SourceGraphic\" in2=\"outerOnly\" operator=\"over\"/>\n        </filter>\n      ";
      defs.innerHTML = gradient + outerGlowFilter;
    });
  }
  if (geoJsonInv) {
    leaflet.geoJSON(sweInv, {
      style() {
        return {
          color: 'rgba(32, 115, 229, 1',
          opacity: 0.36,
          weight: 2,
          fillColor: 'url(#geojsonGradient)',
          fillOpacity: 1
        };
      },
      pane: paneName,
      renderer: mapRenderer
    }).addTo(map);
  }
  if (geoJsonFill) {
    leaflet.geoJSON(swe, {
      style() {
        return {
          fillOpacity: 0.5,
          color: '#fff',
          weight: 1,
          renderer: mapRenderer
        };
      },
      pane: paneName
    }).addTo(map);
  }
  if (geoJson) {
    leaflet.geoJSON(swe, {
      style() {
        return {
          fillOpacity: 0,
          fillColor: 'transparent',
          color: '#1047B8',
          weight: 0.4,
          renderer: mapRenderer,
          className: 'lp-geojson'
        };
      },
      pane: paneName
    }).addTo(map);
  }
  return map;
}
Object.assign(svs.tur.lyckoplatsen.map, {
  createMap,
  mapDefaults,
  sweRectangleBounds,
  worldRectangleBounds
});

 })(window);